export const SELFCARE360_DIMENSION_THRESHOLDS = {
    greenMin: 85,
    yellowMin: 75,
    yellowMax: 84,
    orangeMin: 65,
    orangeMax: 74,
    redMax: 64,
};

export const SELFCARE360_IPRA_THRESHOLDS = {
    lowMin: 85,
    moderateMin: 75,
    moderateMax: 84,
    highMin: 65,
    highMax: 74,
    criticalMax: 64,
};

export const SELFCARE360_DIMENSION_ORDER = [
    'aprendizaje de incidentes',
    'cumplimiento de reglas',
    'liderazgo operativo',
    'planeacion segura',
    'participacion del equipo',
    'stop work authority',
    'controles criticos',
    'gestion de fatiga',
];

export const isIpraService = (serviceId) => Number(serviceId) === 7;

export const roundHalfUp = (value, decimals = 1) => {
    const num = Number(value);
    if (!Number.isFinite(num)) return 0;
    const factor = 10 ** decimals;
    return Math.round((num + Number.EPSILON) * factor) / factor;
};

export const formatVisibleNumber = (value, decimals = 1) => roundHalfUp(value, decimals).toFixed(decimals);

export const formatVisiblePercent = (value, decimals = 1) => `${formatVisibleNumber(value, decimals)}%`;

const getDefaultScoreColor = (value, redLight, yellowLight) => {
    const safeValue = Number(value);
    if (!Number.isFinite(safeValue)) return '#43a047';
    if (safeValue <= redLight) return '#e53935';
    if (safeValue <= yellowLight) return '#fbc02d';
    return '#43a047';
};

// Metadatos fijos para construir la tabla de resumen (referencia plantilla)
// Claves normalizadas: minúsculas, sin tildes.
export const SELFCARE360_DIMENSION_META = {
    'aprendizaje de incidentes': {
        classification: 'Brecha Crítica/Alto riesgo de repetición de eventos',
    },
    'cumplimiento de reglas': {
        classification: 'Brecha Crítica/Normalización de atajos/ incidentes incapacitantes',
    },
    'liderazgo operativo': {
        classification: 'Brecha crítica/ Supervisión inconsistente, prevención - cultura permisiva',
    },
    'planeacion segura': {
        classification: 'Vulnerabilidad/Arranque con riesgo residual- exposición a tareas no controladas.',
    },
    'participacion del equipo': {
        classification: 'Vulnerabilidad cultural/reporte y voz aún limitado.- Menos detección temprana',
    },
    'stop work authority': {
        classification: 'Fortaleza conductual/buena capacidad de detener riesgos, no totalmente sistémica.',
    },
    'controles criticos': {
        classification: 'Fortaleza operativa/barreras técnicas presentes pero aun inconsistentes',
    },
    'gestion de fatiga': {
        classification: 'Vulnerabilidad/Control insuficiente de fatiga y exposición acumulada al riesgo.',
    },
};

export const getSelfcare360IprTier = (value) => {
    const safeValue = Number(value);
    if (!Number.isFinite(safeValue)) {
        return {
            key: 'low',
            color: '#43a047',
            label: 'Riesgo bajo',
            textColor: '#fff',
        };
    }

    if (safeValue >= SELFCARE360_IPRA_THRESHOLDS.lowMin) {
        return { key: 'low', color: '#43a047', label: 'Riesgo bajo', textColor: '#fff' };
    }
    if (safeValue >= SELFCARE360_IPRA_THRESHOLDS.moderateMin) {
        return { key: 'moderate', color: '#fbc02d', label: 'Riesgo moderado', textColor: '#000' };
    }
    if (safeValue >= SELFCARE360_IPRA_THRESHOLDS.highMin) {
        return { key: 'high', color: '#fb8c00', label: 'Riesgo alto', textColor: '#fff' };
    }
    return { key: 'critical', color: '#e53935', label: 'Riesgo crítico', textColor: '#fff' };
};

export const getSelfcare360DimensionTier = (value) => getSelfcare360IprTier(value);

export const getSelfcare360DimensionColor = (value) => getSelfcare360DimensionTier(value).color;

export const getSelfcare360IprColor = (value) => getSelfcare360IprTier(value).color;

export const getSelfcare360IprLabel = (value) => getSelfcare360IprTier(value).label;

export const getEvaluationScoreColor = (value, { redLight, yellowLight, serviceId } = {}) => {
    if (isIpraService(serviceId)) return getSelfcare360DimensionColor(value);
    return getDefaultScoreColor(value, redLight, yellowLight);
};

export const getWeightPercent = (dimension) => {
    const directPercent = Number(dimension?.weight_percent);
    if (Number.isFinite(directPercent)) return directPercent;

    const effectivePercent = Number(dimension?.effective_weight_percent);
    if (Number.isFinite(effectivePercent) && Number(dimension?.validity?.exclude_from_ipra) !== 1) {
        return effectivePercent;
    }

    const directWeight = Number(dimension?.weight);
    if (Number.isFinite(directWeight)) return directWeight * 100;

    const effectiveWeight = Number(dimension?.effective_weight);
    if (Number.isFinite(effectiveWeight)) return effectiveWeight * 100;

    return 0;
};
